<script>
    import { createEventDispatcher, tick } from 'svelte';
    import Link from '../../Link/v1/Link.svelte';

    export let currentPage;
    export let lastPageNumber;
    export let singlePageApp;
    export let showCompactView;
    export let i18n;

    const dispatch = createEventDispatcher();

    async function nextPageHandler(event) {
        event.preventDefault();
        dispatch('nextPage', { page: currentPage + 1 });

        if ((currentPage + 1) === lastPageNumber) {
            let lastPageLink;

            await tick();
            if (showCompactView) {
                lastPageLink = document.querySelector(".prom-pagination__compact-view .prom-pagination__previous-icon");
            } else {
                lastPageLink = document.querySelector(`.prom-pagination__link[href="/?page=${lastPageNumber}"]`);
            }

            if (lastPageLink) {
                lastPageLink.focus();
            }
        }
    }
</script>

<li class="prom-pagination__next">
    {#if (currentPage + 1) <= lastPageNumber}
        <Link 
            kind="standalone"
            iconClass="prom-pagination__next-icon"
            iconPlacement="start"
            href="/?page=${currentPage + 1}"
            label={i18n.next}
            on:click={singlePageApp ? nextPageHandler : undefined}
        />
    {:else}
        <span class="prom-pagination__next--inert prom-pagination__next-icon"></span>
    {/if}
</li>
